import type { Vec2, WorldBounds } from './types'

export function wrapCoord(value: number, max: number): number {
  if (!Number.isFinite(max) || max <= 0) return value
  return ((value % max) + max) % max
}

export function wrapPoint(point: Vec2, bounds: WorldBounds): Vec2 {
  return {
    x: wrapCoord(point.x, bounds.width),
    y: wrapCoord(point.y, bounds.height),
  }
}

export function toroidalDelta(from: number, to: number, size: number): number {
  if (!Number.isFinite(size) || size <= 0) return to - from

  let delta = to - from
  const half = size / 2

  if (delta > half) delta -= size
  if (delta < -half) delta += size

  return delta
}

export function toroidalDistanceSq(a: Vec2, b: Vec2, bounds: WorldBounds): number {
  const dx = toroidalDelta(a.x, b.x, bounds.width)
  const dy = toroidalDelta(a.y, b.y, bounds.height)
  return dx * dx + dy * dy
}
